import React, { useState, useEffect } from 'react';
import configData from "../../config.json";
import ApiServices from '../../services/ApiServices';
import { useHistory } from 'react-router-dom';

export const Collections = ({ onOpenCollection, isMyCollections, changedUserHasCollections }) => {
    const [collections, setCollections] = useState([]);
    const [user, setUser] = useState();
    const history = useHistory();

    useEffect(() => {
        let isMounted = true;

        const loadData = async () => {
            const loggedInUser = localStorage.getItem("user");
            let currentUser = null;

            if (loggedInUser) {
                currentUser = JSON.parse(loggedInUser);
                if (isMounted) setUser(currentUser);
            }

            const data = await ApiServices.getCollections(isMyCollections, currentUser);

            if (!isMounted) return;

            if (changedUserHasCollections) {
                changedUserHasCollections(data && data.length > 0);
            }

            if (data)
                setCollections(data);

        };

        loadData();

        return () => {
            isMounted = false;
        };
    }, []);



    function AddToMyCollection(collection) {
        ApiServices.addToMyCollection(user.userAccountId, collection.collectionId)
            .then((result) => {
                if (result.data.status == 'Success') {
                    //collection.isMyCollection = true;

                    //selectCollection(null);
                    //setUserHasCollections(true);
                    //setChangedCollection(!changedCollection);
                    history.push('/collection/' + collection.collectionId);
                }
                else
                    alert('Er is iets mis gegaan.');
            })
    }

    function onCollectionClick(collection) {
        const loggedInUser = localStorage.getItem("user");

        if (loggedInUser) 
            history.push('/collection/' + collection.collectionId);
        else
            history.push('/login');
    }

    return (
        <div className="collectionsGrid">{
            collections.map((collection) => (
                <div
                    className="collectionCard otherCollection"
                    key={collection.collectionId}>
                    <div className="collectionImageWrapper">
                        <span
                            className={`statusBadge ${collection.active
                                    ? 'active'
                                    : 'ended'
                                }`}>
                            {collection.active
                                ? 'ACTIEF'
                                : 'AFGELOPEN'}
                        </span>

                        <img
                            className="collectionImage"
                            src={
                                configData.BLOB_COLLECTION_URL +
                                collection.imageFile
                            }
                            alt={collection.name}
                        />

                    </div>

                    <div className="collectionContent">

                        <h3 className="collectionTitle">
                            {collection.name}
                        </h3>

                        <div className="collectionMeta">
                            {collection.totalItemCount} plaatjes
                        </div>

                        <div className="collectionDescription">
                            Start direct met verzamelen en vind ruilmatches.
                        </div>

                        <div className="buttonRow">

                            <button className="addButton" onClick={() => onCollectionClick(collection)}>
                                + Toevoegen
                            </button>

                        </div>

                    </div>

                </div>
            ))
        }</div>
    );
}

export default Collections;
